import { createFileRoute } from '@tanstack/react-router'
import { ProcessFlowDiagramBuilderPage } from 'pages/processFlows/ProcessFlowDiagramBuilderPage'

export const Route = createFileRoute('/process-flows/$siteID/$diagramID')({
  component: ProcessFlowDiagramBuilderPage,
  staticData: {
    title: 'Process Flow Diagram',
  },
})
